<template>
  <v-navigation-drawer
    :value="isDrawerOpen"
    app
    floating
    width="260"
    class="app-navigation-menu"
    :right="$vuetify.rtl"
    @input="val => $emit('update:is-drawer-open', val)"
  >
    <!-- Navigation Header -->
    <div class="vertical-nav-header d-flex items-center ps-6 pe-5 pt-5 pb-2">
      <router-link
        to="/Dashboard"
        class="d-flex align-center text-decoration-none"
      >
        <v-img
          :src="require('@/assets/images/logos/logo.png')"
          max-height="140px"
          max-width="140px"
          alt="logo"
          contain
          eager
          center
          class="app-logo mx-auto me-3"
        ></v-img>
        <v-slide-x-transition>
          <h2 class="app-title text--primary">
          </h2>
        </v-slide-x-transition>
      </router-link>
    </div>

    <!-- Navigation Items -->
    <v-list
      expand
      shaped
      class="vertical-nav-menu-items pr-5"
    >
      <nav-menu-link
        title="Dashboard"
        :to="{ name: 'dashboard' }"
        :icon="icons.mdiHomeOutline"
      ></nav-menu-link>

      <nav-menu-link
        v-if="$store.state.user.level_user === 'Product' || $store.state.user.level_user === 'Admin'"
        title="Create New Tour"
        :to="{ name: 'New Tour'}"
        :icon="icons.mdiNotePlus"
      ></nav-menu-link>
      <nav-menu-link
        v-if="$store.state.user.level_user === 'Product' || $store.state.user.level_user === 'Admin'"
        title="Itinerari Data"
        :to="{ name: 'Itinerari Data'}"
        :icon="icons.mdiClipboardList"
      ></nav-menu-link>
      <nav-menu-link
        v-if="$store.state.user.level_user === 'Operational' || $store.state.user.level_user === 'Admin'"
        title="Service Order"
        :to="{ name: 'Service Order'}"
        :icon="icons.mdiRoomService"
      ></nav-menu-link>
      <nav-menu-link
        v-if="$store.state.user.level_user === 'Operational'|| $store.state.user.level_user === 'Accounting' || $store.state.user.level_user === 'Admin'"
        title="Status Payment"
        :to="{ name: 'Status Payment'}"
        :icon="icons.mdiCurrencyUsd"
      ></nav-menu-link>
      <nav-menu-link
        v-if="$store.state.user.level_user === 'Operational'|| $store.state.user.level_user === 'Accounting' || $store.state.user.level_user === 'Admin'"
        title="Invoice"
        :to="{ name: 'invoice'}"
        :icon="icons.mdiCashMultiple"
      ></nav-menu-link>
    </v-list>

    <nav-menu-section-title title="Setting Aplication"></nav-menu-section-title>
    <nav-menu-link
      title="Account Settings"
      :to="{ name: 'pages-account-settings'}"
      :icon="icons.mdiAccountCogOutline"
    ></nav-menu-link>

    <nav-menu-group
      title="All Data"
      :icon="icons.mdiDatabasePlus"
    >
      <nav-menu-link
        title="Agent"
        :to="{ name: 'Agent' }"
        :icon="icons.mdiFaceAgent"
      ></nav-menu-link>

      <nav-menu-link
        title="Guide"
        :to="{ name: 'Guide' }"
        :icon="icons.mdiHumanGreeting"
      ></nav-menu-link>
      <nav-menu-link
        title="Hotel"
        :to="{ name: 'Hotel' }"
        :icon="icons.mdiBedOutline"
      ></nav-menu-link>
      <nav-menu-link
        title="Restaurant"
        :to="{ name: 'Restaurant' }"
        :icon="icons.mdiSilverware"
      ></nav-menu-link>
      <nav-menu-link
        title="Activity"
        :to="{ name: 'Activity' }"
        :icon="icons.mdiRunFast"
      ></nav-menu-link>
      <nav-menu-link
        title="Transport"
        :to="{ name: 'Transport' }"
        :icon="icons.mdiCarMultiple"
      ></nav-menu-link>
      <nav-menu-link
        title="Entrance Fee"
        :to="{ name: 'entrance_fee' }"
        :icon="icons.mdiBoomGate"
      ></nav-menu-link>
      <nav-menu-link
        title="Others"
        :to="{ name: 'Other' }"
        :icon="icons.mdiPlaylistPlus"
      ></nav-menu-link>
      <nav-menu-link
        title="Region"
        :to="{ name: 'Region' }"
        :icon="icons.mdiMapMarkerPlus"
      ></nav-menu-link>
    </nav-menu-group>
  </v-navigation-drawer>
</template>

<script>
// eslint-disable-next-line object-curly-newline
import {
  mdiCurrencyUsd,
  mdiClipboardList,
  mdiHomeOutline,
  mdiAlphaTBoxOutline,
  mdiEyeOutline,
  mdiCreditCardOutline,
  mdiTable,
  mdiFileOutline,
  mdiFormSelect,
  mdiAccountCogOutline,
  mdiFaceAgent,
  mdiHumanGreeting,
  mdiBedOutline,
  mdiSilverware,
  mdiRunFast,
  mdiCarMultiple,
  mdiDatabasePlus,
  mdiNotePlus,
  mdiPlaylistPlus,
  mdiBoomGate,
  mdiMapMarkerPlus,
  mdiRoomService,
  mdiCashMultiple,
  mdiListStatus,
} from '@mdi/js'
import NavMenuSectionTitle from './components/NavMenuSectionTitle.vue'
import NavMenuGroup from './components/NavMenuGroup.vue'
import NavMenuLink from './components/NavMenuLink.vue'

export default {
  components: {
    NavMenuSectionTitle,
    NavMenuGroup,
    NavMenuLink,
  },
  props: {
    isDrawerOpen: {
      type: Boolean,
      default: null,
    },
  },
  setup() {
    return {
      icons: {
        mdiCurrencyUsd,
        mdiClipboardList,
        mdiHomeOutline,
        mdiAlphaTBoxOutline,
        mdiEyeOutline,
        mdiCreditCardOutline,
        mdiTable,
        mdiFileOutline,
        mdiFormSelect,
        mdiAccountCogOutline,
        mdiFaceAgent,
        mdiHumanGreeting,
        mdiBedOutline,
        mdiSilverware,
        mdiRunFast,
        mdiCarMultiple,
        mdiDatabasePlus,
        mdiNotePlus,
        mdiPlaylistPlus,
        mdiBoomGate,
        mdiMapMarkerPlus,
        mdiRoomService,
        mdiCashMultiple,
        mdiListStatus,
      },
    }
  },
}
</script>

<style lang="scss" scoped>
.app-title {
  font-size: 1.25rem;
  font-weight: 700;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 0.3px;
}

// ? Adjust this `translateX` value to keep logo in center when vertical nav menu is collapsed (Value depends on your logo)
.app-logo {
  transition: all 0.18s ease-in-out;
  .v-navigation-drawer--mini-variant & {
    transform: translateX(-4px);
  }
}

@include theme(app-navigation-menu) using ($material) {
  background-color: map-deep-get($material, 'background');
}

.app-navigation-menu {
  .v-list-item {
    &.vertical-nav-menu-link {
      ::v-deep .v-list-item__icon {
        .v-icon {
          transition: none !important;
        }
      }
    }
  }
}

// You can remove below style
// Upgrade Banner
.app-navigation-menu {
  .upgrade-banner {
    position: absolute;
    bottom: 13px;
    left: 50%;
    transform: translateX(-50%);
  }
}
</style>
